import { useState, useEffect } from 'react';
import styled from 'styled-components';
import "@fontsource/source-sans-pro";
import '../../../../index.css';
import { useLocation, useNavigate } from "react-router-dom";
import { useEndpointProvider } from '../../../../Providers/EndpointProvider';
import { FRONTEND_LINKS } from '../../../../Constants/FrontendLinks';
import { InfoMessage, WarningMessage, ErrorMessage, SuccessMessage } from '../../../../Constants/StyledComponents';
import MUITable from '../../../../Components/MUITable/MUITable';
import { localizeDate } from '../../../../Computation/utilFunctions';
import SubpageTabs from '../../../../Components/SubpageTabs/SubpageTabs';
import { SubHeader } from '../Subpages/Components/SubHeader';
import { useBackendLinksProvider } from '../../../../Providers/BackendLinksProvider';

const UploadHistorySubpage = () => {
    const endpointProvider = useEndpointProvider()
    const location = useLocation()
    const { LINKS } = useBackendLinksProvider()

    let navigate = useNavigate()

    const query = new URLSearchParams(useLocation().search);
    const UID = parseInt(query.get("patient_id"))

    const [patient, setPatient] = useState(location?.state)

    useEffect(() => {
        async function getPatient() {
            let body = {
                patient_primary_key: UID,
            }

            if (UID === undefined) {
                alert(`patient_id === undefined`)
                navigate(FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.VISUALIZE.MAIN)
            }

            try {
                const patientData = await endpointProvider.post(LINKS.DATA.PROFILING.GET_PATIENT, body)
                return patientData
            } catch (error) {
                alert(`Patient id=${UID} does not exist.`)
                navigate(FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.VISUALIZE.MAIN)
            }
        }

        if (!patient || Object.keys(patient).length === 0) {
            getPatient().then(patientData => {
                setPatient(patientData)
            })
        }
    }, [UID])

    function truncateString(str) {
        if (str.length > 70) {
            return (
                <span title={str}>
                    {str.slice(0, 70) + '...'}
                </span>
            )
        }
        return str
    }

    const columns = [
        { field: "_timestamp", headerName: "Uploaded", valueGetter: params => localizeDate(Date.parse(params.row._timestamp)), minWidth: 200, visible: true, flex: 1 },
        { field: "email", headerName: "Uploaded By", minWidth: 160, visible: true, valueGetter: params => { return params.row.email }, flex: 1 },
        {
            field: "combined_message", headerName: "Most Recent Message", minWidth: 300, visible: true, renderCell: params => {
                const combined_message = params.row.combined_message
                if (!combined_message) return null

                const words = combined_message.split(" ");
                const messageType = words[0] ? words[0].replace("!", "") : ""

                // Handle empty string or single character case
                const firstWord = words[0] ? words[0].charAt(0).toUpperCase() + words[0].slice(1) : "";
                const restOfMessage = words.length > 1 ? truncateString(words.slice(1).join(" ")) : "";

                // Map message types to corresponding components
                const MessageComponent = {
                    info: InfoMessage,
                    success: SuccessMessage,
                    error: ErrorMessage,
                    warning: WarningMessage,
                    canceled: CanceledMessage
                }[messageType];

                // If we don't have a valid message type, return null
                if (!MessageComponent) return null;

                return (
                    <MessageComponent>
                    <p>
                        <strong>{firstWord}</strong>
                        {restOfMessage && " " + restOfMessage}
                    </p>
                    </MessageComponent>
                );
            },
            flex: 1
        },
    ]

    const uploadTableToolbarProps = {
        createButton: { title: "Upload patient", isShow: false },
        deleteButton: { title: "Delete", isShow: false, },
        filterButton: { title: "Filter", isShow: false },
        exportButton: { isShow: false },
        searchInput: { isShow: true },
        mainTable: true
    }

    const uploadProps = {
        queryKey: "upload",
        endpoint: LINKS.DATA.UPLOAD.GET_UPLOAD_MESSAGES,
        body: { patient_id: UID },
    }

    return (
        <div>
            <SubpageTabs UID={UID} patient={patient} currentTab={'Uploads'} />

            <div style={{ padding: "0 32px", display: "flex", flexDirection: "row", width: "100%", position: "relative", justifyContent: 'space-between' }}>
                <SubHeader patient={patient}
                    startSlotChildren={[]}
                />
            </div>

            <MUITable columns={columns} tableToolbarProps={uploadTableToolbarProps} {...uploadProps} isCheckboxSelection={false} isRowSelectable={() => false} />

        </div>
    )
};

const CanceledMessage = styled.div`
	background: #FDE8B2;
	height: 30px;
	padding: 8px 8px;
	border-radius: 6px;
	p {
		color: #A66E00;
	}
`;

export default UploadHistorySubpage;